import { Api } from "@/plugins/api"

export const loadAddress = ({ token, mode }) => {
  return Api.get('address-complete/address/' + mode, {
    headers: { Authorization: 'Basic ' + token }
  })
}
export const updateAddress = ({ token, mode, address }) => {
  return Api.post('address-complete/address/' + mode, address, {
    headers: { Authorization: 'Basic ' + token }
  })
}